export default __webpack_public_path__ + "static/media/Andor.6c1a4d44.png";